export enum SupportTicketStatus {
  TO_DO = "TODO",
  ONGOING = "ONGOING",
  COMPLETED = "COMPLETED",
}

export const SupportConstants = {
  CONTENT_TEXT: {
    HEADER: "Support",
    TEAM_CONTACT: "Team Contact",
    IMPORTANT_DOCUMENT: "Important Document",
    ADD_CONTACT: "Add Team Contact",
    TICKET_DELETE_CONFIRMATION: "Are you sure you want to delete this ticket?",
    TEAM_CONTACT_DELETE_CONFIRMATION:
      "Are you sure you want to delete this team contact? You can't undo this action.",
    IMPORTANT_DOCUMENT_DELETE_CONFIRMATION:
      "Are you sure you want to delete this important document? You can't undo this action.",
    ADD_IMPORTANT_DOCUMENT: "Add Important Doc",
  },
  EMPTY_MESSAGE: {
    NO_TICKETS_IN_BOARD: "No support tickets found",
  },
  BOARD_COLUMN: {
    TODO: {
      id: SupportTicketStatus.TO_DO,
      title: "To Do ✍️",
    },
    ONGOING: {
      id: SupportTicketStatus.ONGOING,
      title: "Ongoing 🏄‍♂️",
    },
    COMPLETED: {
      id: SupportTicketStatus.COMPLETED,
      title: "Completed ✅",
    },
  },
  TOAST_MESSAGES: {
    SUCCESS: {
      STATUS_UPDATED: "Ticket Status Updated Successfully",
      DELETED_SUPPORT_TICKET: "Support Ticket Deleted Successfully",
      ADDED_TEAM_CONTACT: "Team Contact Added Successfully",
      UPDATED_TEAM_CONTACT: "Team Contact Updated Successfully",
      DELETED_TEAM_CONTACT: "Team Contact Deleted Successfully",
      ADDED_IMPORTANT_DOCUMENT: "Important Document Added Successfully",
      DELETED_IMPORTANT_DOCUMENT: "Important Document Deleted Successfully",
      UPDATED_IMPORTANT_DOCUMENT: "Important Document Updated Successfully",
      UPDATED_SUPPORT_TICKET_TABLE: "Support Ticket Table Updated Successfully",
      UPDATED_TEAM_CONTACT_TABLE: "Team Contact Table Updated Successfully",
      UPDATED_IMPORTANT_DOCUMENT_TABLE:
        "Important Document Table Updated Successfully",
    },
    ERROR: {
      STATUS_UPDATE_FAILED: "Failed to update ticket status",
    },
  },
  TASK_SHEET: {
    SUPPORT_TICKET: "Support Ticket",
    COMMENTS: "Comments",
    ADD_COMMENT: "Write comment...",
    SEND: "Send",
  },
  FORM: {
    TEAM_CONTACT: {
      HEADER: "Add Team Contact",
      SAVE_BTN: "Save Team Contact",
      UPDATE_HEADER: "Edit Team Contact",
    },
    IMPORTANT_DOCUMENT: {
      HEADER: "Add Important Document",
      SAVE_BTN: "Save Important Doc",
      UPDATE_HEADER: "Update Important Document",
    },
  },
};

export const SupportTicketKeys = {
  TICKET_ID: "ticketId",
  TEAM_CONTACT_ID: "teamContactId",
  IMPORTANT_DOCUMENT_ID: "importantDocumentId",
};
